module.exports = __webpack_public_path__ + "static/media/BLZZ.e62a22bb.svg";